import React, { useEffect, useState } from "react";
import { Table, Spinner, Badge, Button, Collapse } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { LMSBASEURL } from "../../config/apiUrls";
import PageHeader from "../../components/PageHeader";
import NoDataFound from "../../components/NoDataFound";
import Swal from "sweetalert2";

const POLL_INTERVAL = 4000;

const GetStudentImport = () => {
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDetailId, setOpenDetailId] = useState(null); // store which import's detail is open

  const [searchParams,setSearchParams] = useSearchParams();
  const navigateFlag = searchParams.get("navigate");
  const InstituteId = sessionStorage.getItem("instituteId");
  const token = process.env.REACT_APP_API_TOKEN;

  useEffect(() => {
    fetchImports();
  }, []);

  const fetchImports = async () => {
    const raw = JSON.stringify({
        "institute_id": InstituteId
    });

    try {
      const res = await fetch(`${LMSBASEURL}/api/import-progress-list`, {
        method:"POST",
        headers: { 
            Authorization: token, 
            Accept: "application/json",
            "Content-Type": "application/json"
 
        },
        body:raw,
      });
      const result = await res.json();
      const importsList = result.data || [];
      setImports(importsList);
      setLoading(false);

      if (navigateFlag === "true") {
        importsList
          .filter((i) => i.status === "ongoing")
          .forEach((i) => pollImportProgress(i.import_id));
      }
    } catch (err) {
      console.error("Error fetching imports:", err);
      setLoading(false);
    }
  };

  const pollImportProgress = (importId) => {
    const poll = async () => {
      try {
        const res = await fetch(`${LMSBASEURL}/api/import-progress/${importId}`, {
          headers: { Authorization: token, Accept: "application/json" },
        });
        const result = await res.json();
        searchParams.delete('navigate');
        setSearchParams({});

        if (result.success) {
          if (result.status === "failed") {
            clearInterval(intervalId);
            Swal.fire({
              icon: "error",
              title: "Import Failed",
              text: "Something went wrong during the import process.",
              confirmButtonColor: "#d33",
            });
            return;
          }
          setImports((prev) =>
            prev.map((item) =>
              item.import_id === importId
                ? {
                    ...item,
                    total_rows: result.total_rows,
                    processed_rows: result.processed_rows,
                    success_count: result.success_count,
                    duplicate_count: result.duplicate_count,
                    error_count: result.error_count,
                    status:
                      result.processed_rows === result.total_rows
                        ? "ended"
                        : "inprogress",
                    batch_logs: result.batch_logs || item.batch_logs, // update batch_logs if API returns new
                  }
                : item
            )
          );

          if (result.processed_rows === result.total_rows) {
            clearInterval(intervalId);
          }
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    };

    const intervalId = setInterval(poll, POLL_INTERVAL);
    poll();
  };

  const renderStatus = (status) => {
    if (status === "inprogress") {
      return (
        <div className="d-flex align-items-center">
          <Spinner animation="border" size="sm" className="me-2" />
          <span>In Progress</span>
        </div>
      );
    } else if (status === "ended") {
      return <Badge bg="success">Completed</Badge>;
    } else {
      return <Badge bg="danger">{status}</Badge>;
    }
  };

  return (
    <div>
        <div className="col-12">
            <PageHeader title="Import Progress" 
                breadcrumbs={[
                { label: "Dashboard", path: "/institute-dashboard" },
                { label: "Import Progress", active: true }
                ]}
            />
        </div>
        <div className="py-2">

        {loading ? (
            <div className="text-center my-5">
            <Spinner animation="border" variant="primary" />
            </div>
        ) : (
            <>{imports?.length ==0?<NoDataFound message="No Student Import Progress found" isEnroll/>:
                <Table bordered hover responsive className="align-middle shadow-sm">
                    <thead className="table-light">
                        <tr>
                        {/* <th>Import ID</th> */}
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total Rows</th>
                        <th>Success</th>
                        <th>Duplicates</th>
                        <th>Failed</th>
                        {/* <th>Action</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {imports.map((item) => (
                        <React.Fragment key={item.import_id}>
                            <tr>
                            {/* <td>{item.import_id}</td> */}
                            <td>{new Date(item.created_at).toLocaleString()}</td>
                            <td>{renderStatus(item.status)}</td>
                            <td>{item.total_rows}</td>
                            <td>{item.success_count}</td>
                            <td>{item.duplicate_count}</td>
                            <td>{item.error_count}</td>
                            {/* <td>
                                {item.batch_logs && item.batch_logs.length > 0 && (
                                <Button
                                    size="sm"
                                    variant="info"
                                    onClick={() =>
                                    setOpenDetailId(
                                        openDetailId === item.import_id ? null : item.import_id
                                    )
                                    }
                                >
                                    {openDetailId === item.import_id ? "Hide Details" : "Details"}
                                </Button>
                                )}
                            </td> */}
                            </tr>
                            {/* Nested table for batch_logs */}
                            {/* <tr>
                            <td colSpan="8" className="p-0 border-0">
                                <Collapse in={openDetailId === item.import_id}>
                                <div className="p-3 bg-light">
                                    <Table bordered size="sm" responsive>
                                    <thead className="table-secondary">
                                        <tr>
                                        <th>Batch Number</th>
                                        <th>Rows in Batch</th>
                                        <th>Success</th>
                                        <th>Duplicates</th>
                                        <th>Failed</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item.batch_logs.map((batch) => (
                                        <tr key={batch.batch_number}>
                                            <td>{batch.batch_number}</td>
                                            <td>{batch.rows_in_batch}</td>
                                            <td>{batch.success}</td>
                                            <td>{batch.duplicates}</td>
                                            <td>{batch.errors}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    </Table>
                                </div>
                                </Collapse>
                            </td>
                            </tr> */}
                        </React.Fragment>
                        ))}
                    </tbody>
                </Table>}
            </>
        )}
        </div>
    </div>
  );
};

export default GetStudentImport;
